/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    CODE: 'Code',
    COUNTERPARTS: 'Gegenleistungen',
    CURRENT: 'Aktuell',
    GENERAL_INFORMATION: 'Allgemeine Informationen',
    MANAGER: 'Manager',
    PREVIOUS: 'Zurück',
    PRODUCTS: 'Produkte',
    REMUNERATION: 'Vergütungen',
    SUPERVISOR: 'Supervisor'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
